import React, { useEffect, useState } from "react";
import "./SecondaryNavigation.scss";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";

const SecondaryNavigation = (props) => {
  const className = props.className
    ? `${props.className} instream-secondary-navigation`
    : "instream-secondary-navigation";

  const handleClick = (item) => {
    props.onClick(item);
  };

  const generateOptions = (options) => {
    return options.map((option) => {
      let optionClassName = "instream-secondary-navigation-option";
      if (option.selected)
        optionClassName = "instream-secondary-navigation-option-active";
      return (
        <ListItem
          className={optionClassName}
          onClick={() => handleClick(option)}
        >
          <div className="label">{option.label}</div>
        </ListItem>
      );
    });
  };

  return (
    <List className={className}>
      <ListItem className="instream-secondary-navigation-header">
        <div className="label">{props.header}</div>
      </ListItem>
      <Collapse in={true}>
        <List disablePadding>{generateOptions(props.options)}</List>
      </Collapse>
    </List>
  );
};

export default SecondaryNavigation;
